// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/campaign-zones/CampaignZonesEntry"),
  iconType: "heat-map",
  name: "campaign-zones",
  subApps: [
    {
      name: "campaigns",
      requirePermission: ["campaign:view"]
    },
    {
      name: "zones",
      requirePermission: ["campaign-zones:view"]
    }
  ]
}: AppType)
